@if (variant() === 'icon') {
  <img
    class="re-app-brand-logo__img"
    src="assets/logo.png"
    alt=""
    aria-hidden="true"
    decoding="async"
  />
} @else {
  <img
    class="re-app-brand-logo__img"
    src="assets/image.png"
    [alt]="'common.appName' | translate"
    decoding="async"
  />
}
